import React from 'react';
import styles from './ChargingMethodSelector.module.css';
import { LuCalendarClock, LuCalendarOff } from "react-icons/lu";
import { Table, Input, Button, Space, Select } from "antd";
import { TbHome } from "react-icons/tb";

const ChargingMethodSelector = ({ selected, onSelectionChange, nonReservableCount = null, onNonResSearch, resCount, nonResCount, subLocations, condoSubLocations = [], selectedSubLocationId, onSubLocationChange, location }) => {
  const [searchValue, setSearchValue] = React.useState('');
// console.log('ChargingMethodSelector location', location);
  React.useEffect(() => {
    // clear search when switching away from non-reservable
    if (selected !== 'non-reservable' && searchValue) {
      setSearchValue('');
      onNonResSearch?.('');
    }
  }, [selected]);

  const handleSearchChange = (e) => {
    const val = e.target.value || '';
    setSearchValue(val);
    onNonResSearch?.(val);
  };

  const defineSelector = () => {
    let isCONDO = subLocations && subLocations.length > 0 && subLocations[0].subLocationType === "CONDO";
    if (resCount !== 0 && nonResCount !== 0 && isCONDO) {
      return (
        <>
          <span className={`${styles['btn-container']} ${styles['three-tab']}`} data-selected={selected}>
            {
              subLocations && subLocations.length > 0 && subLocations[0].subLocationType === "CONDO" && (
                <span
                  className={`${styles['btn-item']} ${selected === 'home' ? styles['active'] : ''}`}
                  onClick={() => onSelectionChange('home')}
                >
                  <TbHome /> Home
                </span>
              )
            }
            <span
              className={`${styles['btn-item']} ${selected === 'reservable' ? styles['active'] : ''}`}
              onClick={() => onSelectionChange('reservable')}
            >
              <LuCalendarClock /> Reservable
            </span>
            <span
              className={`${styles['btn-item']} ${selected === 'non-reservable' ? styles['active'] : ''}`}
              onClick={() => onSelectionChange('non-reservable')}
            >
              <LuCalendarOff /> Non-reservable
            </span>
           
            
          </span>
          <select
            className={styles['three-tab-dropdown']}
            value={selected}
            onChange={(e) => onSelectionChange(e.target.value)}
          >
            <option value="home">Home</option>
            <option value="reservable"><LuCalendarClock />Reservable</option>
            <option value="non-reservable"><LuCalendarOff />Non-reservable</option>
            
          </select>
         
        </>
      )
    } else if (resCount !== 0 && nonResCount !== 0) {
      return (
        <span className={styles['btn-container']} data-selected={selected}>
          <span
            className={`${styles['btn-item']} ${selected === 'reservable' ? styles['active'] : ''}`}
            onClick={() => onSelectionChange('reservable')}
          >
            <LuCalendarClock /> Reservable
          </span>
          <span
            className={`${styles['btn-item']} ${selected === 'non-reservable' ? styles['active'] : ''}`}
            onClick={() => onSelectionChange('non-reservable')}
          >
            <LuCalendarOff /> Non-reservable
          </span>
        </span>
      )
    } else if(resCount !== 0 && isCONDO){
      return (
        <span className={styles['btn-container']} data-selected={selected}>
          <span
            className={`${styles['btn-item']} ${selected === 'home' ? styles['active'] : ''}`}
            onClick={() => onSelectionChange('home')}
          >
            <TbHome /> Home
          </span>
          <span
            className={`${styles['btn-item']} ${selected === 'reservable' ? styles['active'] : ''}`}
            onClick={() => onSelectionChange('reservable')}
          >
            <LuCalendarClock /> Reservable
          </span>
          
        </span>
      )
    } else if(nonResCount !== 0 && isCONDO){
      return (
        <span className={styles['btn-container']} data-selected={selected}>
          <span
            className={`${styles['btn-item']} ${selected === 'home' ? styles['active'] : ''}`}
            onClick={() => onSelectionChange('home')}
          >
            <TbHome /> Home
          </span>
          <span
            className={`${styles['btn-item']} ${selected === 'non-reservable' ? styles['active'] : ''}`}
            onClick={() => onSelectionChange('non-reservable')}
          >
            <LuCalendarOff /> Community
          </span>
          
        </span>
      )
    }
  }
  // console.log('resCount, nonResCount,selected', resCount, nonResCount, selected);
  return (
    <div className={`${styles['charging-method-btn']} ${styles[selected]}`}>
      { 
      // (resCount !==0 && nonResCount !==0) &&
        defineSelector()
      }
      {
        (selected === 'home' && condoSubLocations.length > 1) && (
          <span className={styles['sub-location-select']}>
            <Select
              value={selectedSubLocationId}
              onChange={(id) => onSubLocationChange?.(id)}
              options={condoSubLocations.map((loc) => ({ value: loc._id, label: loc.locationName }))}
              popupMatchSelectWidth={false}
            />
          </span>
        )
      }
      {
        (selected === 'non-reservable' && (nonReservableCount>6 || searchValue.length > 0)) && (
          <span className={styles['non-res-count']}>
            <Input placeholder="Enter Charger Number" value={searchValue} onChange={handleSearchChange} allowClear />
          </span>
        )
      }
      {false && <div className={styles['power-outage-warning']} role="alert">
        {/* <LuTriangleAlert className={styles['power-outage-warning-icon']} /> */}
        <span>
          Chargers are down due to a power issue. Plug in, note your charger number (a photo helps), and we’ll call to start your session once power’s back. Thanks for your patience!
        </span>
      </div>}
    </div>
  );
};

export default ChargingMethodSelector;
